import PhotosModal from "./PhotosModal";

export default PhotosModal